module.exports = new __parcel__URL__("Charlie_Display-Light_Italic.26c12e84.woff").toString();